import { onceVisible } from '@/modules/public/shared/concierge/concierge';

// Hire guide content links to absolute https://www.tagvenue.com/... URLs, which wouldn't match
// the current host on local or mastance.
const TAGVENUE_HOST = /(^|\.)tagvenue\.com$/;

function isInternalLink(link) {
  return link.hostname === window.location.hostname || TAGVENUE_HOST.test(link.hostname);
}

function track(element, interaction, elementValue = '') {
  App.track.event('location_page_interaction', {
    section: 'hire_guide',
    element,
    ...(elementValue && { element_value: elementValue }),
    interaction,
  });
}

function trackLinkClick(link) {
  if (isInternalLink(link)) {
    track('internal_link', 'click', link.pathname + link.search);
  } else {
    track('external_link', 'click', link.href);
  }
}

export function init() {
  const hireGuide = document.querySelector('.js-hire-guide');

  if (!hireGuide) {
    return;
  }

  onceVisible(hireGuide, () => track('', 'visible'));

  hireGuide.addEventListener('click', (e) => {
    const link = e.target.closest('a[href]');

    if (link) {
      trackLinkClick(link);
    } else if (e.target.closest('.js-show-more')) {
      track('show_more_button', 'click');
    } else if (e.target.closest('.js-show-more--undo')) {
      track('show_less_button', 'click');
    }
  });
}
